import './menuOptions.scss';

import React, { useState } from 'react'
import LocalizedLink from '../LocalizedLink';
import { SvcLogo } from '../image-router';
import { FacebookLogo } from '../image-router';
import { LogoIcon } from '../image-router';
import { LogoName } from '../image-router';
import { useTranslation } from 'react-i18next';
import { Nav, Navbar } from 'react-bootstrap';
import useLocalizedNavigate from '../../hooks/useLocalizedNavigate';
import LanguageToggle from '../LanguageToggle';

const MenuOptions = () => {
    const { t } = useTranslation();
    const navigate = useLocalizedNavigate();
    const handleButton = () => {
        window.open("https://www.paypal.com/donate/?hosted_button_id=NP4DH8ZJ2XJKU", '_blank', 'noopener,noreferrer');
    };

    const handleLogo = () => {
        navigate("/");
    };
    return (
        <>
            <Navbar collapseOnSelect expand='lg'>
                <Nav.Item >
                    <img src={LogoIcon} onClick={handleLogo} alt="Logo" className='logoSize clickable-image' />
                </Nav.Item>
                <Navbar.Toggle aria-controls='responsive-navbar-nav' />
                <Navbar.Collapse id='responsive-navbar-nav'>
                    <Nav justify='true' className='pb-2 nav marginLeft'>
                        <Nav.Item className='mt-5'>
                            <LocalizedLink className='underLine' to="/ours" >{t('nav.ours')}</LocalizedLink>
                        </Nav.Item>
                        <Nav.Item className='mt-5'>
                            <LocalizedLink className='underLine' to="/howHelp">{t('nav.howHelp')}</LocalizedLink>
                        </Nav.Item>
                        <Nav.Item className='mt-5'>
                            <LocalizedLink className='underLine' to="/contact">{t('nav.contact')}</LocalizedLink>
                        </Nav.Item>
                        <Nav.Item className='mt-5'>
                            <LocalizedLink className='underLine' to="/blog">{t('nav.blog')}</LocalizedLink>
                        </Nav.Item>
                        <Nav.Item className='mt-5'>
                            <button className='MenuOptionsContainer__buttonStyle underLine' onClick={handleButton}>{t('nav.donate')}</button>
                        </Nav.Item>
                        <Nav.Item className='d-none d-lg-block'>
                            <img src={SvcLogo} alt="Logo" />
                        </Nav.Item>
                        <Nav.Item className='mt-4 mt-lg-5 text-center'>
                            <LanguageToggle />
                        </Nav.Item>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </>
    )
}

export default (MenuOptions);
